import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatDividerModule } from '@angular/material/divider';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs';
import { DateTime } from 'luxon';
import { DeleguesService } from 'src/app/services/delegues.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { DelegationModalComponent } from './delegation-modal/delegation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { EditAgentComponent } from './edit-agent/edit-agent.component';
import { AgentsService } from 'src/app/core/services/agents.service';
import { RoleService } from 'src/app/core/services/role.service';

@Component({
  selector: 'app-gestion-delegations',
  imports: [
    ArianeNavComponent,
    MatFormFieldModule,
    MatDividerModule,
    DataTableComponent,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule
  ],
  templateUrl: './gestion-delegations.component.html',
  styleUrls: ['./gestion-delegations.component.scss']
})
export class GestionDelegationsComponent implements OnInit {
  @ViewChild('appDataTable') appDataTable!: DataTableComponent;

  arianeLabel: string = 'Gestion des utilisateurs';
  arianeIcon: string = 'person';
  arianeList = [
    {
      label: 'Administration',
      url: '/pama/administration'
    },
    {
      label: 'Gestion des utilisateurs',
      url: '/pama/administration/gestion-delegations'
    }
  ];
  filterValue: string = '';
  dataTable_listeAgents: any[] = [];
  filteredOptions: any = [];
  currentDisplayedIndex: number = -1;
  lenght: number;
  dataJSON: any[] = [];
  dataSource: any;
  userRoles: string[] = [];
  rowAgent: any = {};

  pipe = new DatePipe(/*'fr-FR'*/ 'en-US');
  agentsList: any[] = [];

  agentDisplayedColumns: string[] = [
    'Nom',
    'Prénom',
    'Email',
    'Login',
    'Dernière connexion',
    'Collectivité',
    'Structure',
    'DG',
    'Profil',
    'Matricule',
    'Direction',
    'Service',
    'Nombre de délégués',
    'Etat',
    'Statut',
    'Fonction',
    'Notif. Directeur',
    "Taux d'emploi",
    "Entrée dans l'org.",
    'Type de contrat',
    'Début contrat',
    'Fin contrat',
    'Actions'
  ];

  agentCellStyleCss: any = {
    Matricule: { 'text-align': 'center', 'padding-right': '30px' },
    Direction: { 'text-align': 'center', 'padding-right': '30px' },
    Service: { 'text-align': 'center', 'padding-right': '30px' },
    Etat: { 'text-align': 'center' },
    'Nombre de délégués': { 'text-align': 'center' },
    Statut: { 'text-align': 'center' },
    'Notif. Directeur': { 'text-align': 'center' },
    DG: { 'text-align': 'center' },

    "Taux d'emploi": { 'text-align': 'center' },
    "Entrée dans l'org.": { 'text-align': 'center' },
    'Type de contrat': { 'text-align': 'center' },
    'Début contrat': { 'text-align': 'center' },
    'Fin contrat': { 'text-align': 'center' }
  };

  constructor(
    private readonly agentService: AgentsService,
    private readonly delegueservice: DeleguesService,
    private readonly detectorRef: ChangeDetectorRef,
    private readonly roleService: RoleService,
    public readonly dialog: MatDialog,

    public agentDialog: MatDialog
  ) {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource();
    this.roleService.getRole().subscribe((roles) => {
      this.userRoles = roles;
    });
    this.listeAgentsLoading();
  }

  listeAgentsLoading(filtre = null) {
    this.agentService
      .getAgentDelegationWithParams(environment.pagination.offset, environment.pagination.limit, filtre)
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          this.dataJSON = result.results;
          this.dataTable_listeAgents = this.transformDataListeAgent();
          this.detectorRef.markForCheck();
          this.lenght = result.totalRecords;
        },
        error: (error) => {}
      });
  }
  fitlerAgentsLoading(offset: number, limit: number, filtre = null) {
    this.agentService
      .getAgentDelegationWithParams(offset, limit, filtre)
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          console.log('result', result);

          this.dataJSON = result.results;
          this.dataTable_listeAgents = this.transformDataListeAgent();
          this.detectorRef.markForCheck();
          this.lenght = result.totalRecords;
        },
        error: (error) => {
          console.log('erreur:', error);
        }
      });
  }
  updateFiltre(value: any) {
    this.filterValue = value.filterValue;
    this.updatePagination(value);
  }
  updatePagination(event: any) {
    if (event) {
      this.agentService
        .getAgentDelegationWithParams(event.offset, event.limit, event.filterValue)
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            this.dataJSON = result.results;
            this.dataTable_listeAgents = this.transformDataListeAgent();
            this.detectorRef.markForCheck();
            this.lenght = result.totalRecords;
          },
          error: (error) => {}
        });
    } else {
      this.agentService
        .getAgentDelegationWithParams(environment.pagination.offset, environment.pagination.limit)
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            this.dataJSON = result.results;
            this.dataTable_listeAgents = this.transformDataListeAgent();
            this.detectorRef.markForCheck();
            this.lenght = result.totalRecords;
          },
          error: (error) => {}
        });
    }
  }

  formatDate(date: string) {
    const ma_date = DateTime.fromISO(date);
    return ma_date.isValid ? ma_date.toFormat("dd/MM/yyyy  HH':'mm") : '';
  }
  transformDataListeAgent() {
    let dataAgent: any[] = [];

    for (let key in this.dataJSON) {
      let dataJ = this.dataJSON[key];

      let _data: any = {};
      _data['id'] = dataJ?.id;
      _data['Nom'] = dataJ['nom'];
      _data['Prénom'] = dataJ['prenom'];
      _data['Matricule'] = dataJ['matricule'];
      _data['Email'] = dataJ['email'];
      _data['Login'] = dataJ['login'];
      _data['Dernière connexion'] = this.formatDate(dataJ['dateDerniereConnexion']);
      _data['Collectivité'] = dataJ['collectivite'];
      _data['Structure'] = dataJ['structure'];
      _data['Profil'] = dataJ['profil']; //
      _data['Direction'] = dataJ['direction']?.libelle;
      _data['Service'] = dataJ['serviceFonctionnel']?.libelle;

      _data['Nombre de délégués'] = '...';
      this.delegueservice.getDeleguesAgent(dataJ?.id).subscribe((total) => {
        _data['Nombre de délégués'] = total.totalRecords;
      });
      _data["Taux d'emploi"] = dataJ['tauxEmploi'] ?? '';
      _data["Entrée dans l'org."] = dataJ['dateEntree'] ? this.formatDate(dataJ['dateEntree']).split(' ')[0] : '';
      _data['Début contrat'] = dataJ['dateDebutContrat'] ? this.formatDate(dataJ['dateDebutContrat']).split(' ')[0] : '';
      _data['Fin contrat'] = dataJ['dateFinContrat'] ? this.formatDate(dataJ['dateFinContrat']).split(' ')[0] : '';

      dataAgent.push(_data);

      let status_code = dataJ['actif'];
      let status_text = '';
      let status_class = '';

      if (status_code === true) {
        status_class = 'badge-green-actif';
        status_text = 'Actif';
      } else if (status_code === false) {
        status_class = 'badge-gray-inactif';
        status_text = 'Inactif';
        _data['editUserInactif'] = false;
        _data['addUserInactif'] = true;
      }

      _data['Etat'] = { class: status_class, text: status_text };

      _data['Fonction'] = dataJ['fonction'];
      _data['Notif. Directeur'] = dataJ['flagANotifier'];
      _data['DG'] = dataJ['flagDG'] ? 'DG' : 'NON DG';
      _data['Type de contrat'] = dataJ['libelleTypeCT'];

      _data['Statut'] = dataJ['statut'];
      let status = dataJ['flagANotifier'];
      let label = '';
      let styleclass = '';

      if (status === true) {
        styleclass = 'badge-green-statut';
        label = 'True';
      } else if (status === false) {
        styleclass = 'badge-red-statut';
        label = 'False';
      }
      _data['Notif. Directeur'] = { class: styleclass, text: label };
    }

    return dataAgent;
  }
  searchDataID(data: any, id: number) {
    let index = Object.keys(data).find((k) => data[k].id === id);

    if (index != null) {
      this.rowAgent = this.dataJSON[Number(index)];
    }
  }
  addDelagate(agent: any) {
    const agentId = agent.id;
    this.searchDataID(this.dataJSON, agentId);
    this.agentDialog
      .open(DelegationModalComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
        data: {
          agentId: agentId,
          agentName: this.rowAgent.nom,
          agentPrenom: this.rowAgent.prenom,
          agentMatricule: this.rowAgent.matricule,
          viewMode: 'edit'
        }
      })
      .afterClosed()
      .subscribe((action) => {
        if (action) {
          this.listeAgentsLoading();
          this.detectorRef.markForCheck();
        }
      });
  }
  displayDetailsDelegate(id: any) {
    let idxAgent = -1;
    this.dataJSON.forEach((agent) => {
      idxAgent++;
      if (agent.id === id) {
        this.currentDisplayedIndex = idxAgent;
      }
    });

    this.searchDataID(this.dataJSON, id);
    this.agentDialog.open(DelegationModalComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        agentId: id,
        agentName: this.rowAgent.nom,
        agentPrenom: this.rowAgent.prenom,
        viewMode: 'read',
        agentData: this.rowAgent
      }
    });
  }

  modifierDelegateAgent(rowCheck: number) {
    const rowdata = this.dataJSON.find((agent) => agent.id === rowCheck);

    this.dialog
      .open(EditAgentComponent, {
        width: '900px',
        data: {
          id: rowCheck,
          rowElement: rowdata
        }
      })
      .afterClosed()
      .subscribe((result) => {
        this.listeAgentsLoading();
      });
  }
}
